import get from 'lodash/get'
import find from 'lodash/find'
import { spiritBaseFareAncillaries } from '../FareBrandDrawer/getUpsellOptionsBySlice/getSpiritAncillaries'
import { silverAirlinesAncillaries, baseFareCarriers } from '../../constants'

export function getItinAirlines(itinerary) {
  let airlines = []

  if (get(itinerary, 'airlines')) {
    const itinAirlines = itinerary.airlines.map((airline) => airline.marketingAirline)
    airlines = [...new Set(itinAirlines)]
  }

  return airlines
}

export function getCabinNames(itinerary, brandReference) {
  const fareFamilies = []
  itinerary.slices.forEach((slice) => {
    const brandId = get(slice, 'segments[0].brandId', '')
    const brandData = find(brandReference, ['brandId', brandId])
    if (brandData) {
      fareFamilies.push(brandData.name)
    }
  })
  return fareFamilies
}

export function getBrandAttributeInclusion(brandAttributes, type) {
  const brandAttribute = find(brandAttributes, ['type', type], {})
  return get(brandAttribute, 'inclusion', 'NOT_INCLUDED')
}

export function getBrandAttributesForAirline(brandAttributes, airlines) {
  const airlineCode = airlines?.[0]?.code
  if (airlineCode === silverAirlinesAncillaries.airlineCode) {
    return silverAirlinesAncillaries.brandAttributes
  } else if (baseFareCarriers.includes(airlineCode)) {
    return spiritBaseFareAncillaries.brandAttributes
  }
  return brandAttributes
}

export function getSBSBrandAttributes(brandAttributes, airlines) {
  const airlineCode = airlines?.[0]?.code
  if (airlineCode === silverAirlinesAncillaries.airlineCode) {
    return silverAirlinesAncillaries.brandAttributes
  }
  return brandAttributes
}
